"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDurationToDateRangeValue = exports.getDateRangeSearchKey = exports.removeTimeFromDateRange = exports.isEmptyDateRange = exports.isDateRangesEqual = exports.isDateRangeValue = exports.dateRangeDaysDiff = exports.generateDisplayFormatDates = exports.calculateDateRangePercentProgress = exports.swapDateRangeBoundaries = exports.dateRangeDateTimePasteFormat = exports.dateRangeDatePasteFormat = exports.dateRangeToMoment = exports.emptyDateRange = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const date_fns_1 = require("date-fns");
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const types_1 = require("@smartsuite/types");
const date_1 = require("./date");
const object_1 = require("./object");
function emptyDateRange() {
    return {
        from_date: {
            date: null,
            include_time: false,
        },
        to_date: {
            date: null,
            include_time: false,
        },
    };
}
exports.emptyDateRange = emptyDateRange;
/**
 * Convert DateRange to MomentDateRange
 */
function dateRangeToMoment(dateRange, userPreferences) {
    var _a, _b, _c, _d;
    if (!dateRange || dateRange === emptyDateRange()) {
        return {
            from_date: { date: null, include_time: false },
            to_date: { date: null, include_time: false },
        };
    }
    return {
        from_date: {
            date: ((_a = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _a === void 0 ? void 0 : _a.date)
                ? (0, date_1.dateToMoment)(dateRange.from_date, userPreferences)
                : null,
            include_time: ((_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _b === void 0 ? void 0 : _b.include_time) || false,
        },
        to_date: {
            date: ((_c = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _c === void 0 ? void 0 : _c.date)
                ? (0, date_1.dateToMoment)(dateRange.to_date, userPreferences)
                : null,
            include_time: ((_d = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _d === void 0 ? void 0 : _d.include_time) || false,
        },
    };
}
exports.dateRangeToMoment = dateRangeToMoment;
/**
 * @deprecated Use datePasteFormats instead
 */
function dateRangeDatePasteFormat(dateFormat = "MM/DD/YYYY") {
    const delimiters = ["", " ", ".", ",", "/", "-"];
    let dateFormats;
    if (dateFormat.startsWith("M")) {
        dateFormats = [
            "M",
            "M/D",
            "D",
            "D/M",
            "M/D/YY",
            "D/M/YY",
            "YY/M/D",
            "YY/D/M",
            "M/D/YYYY",
            "D/M/YYYY",
            "YYYY/M/D",
            "YYYY/D/M",
        ];
    }
    else {
        dateFormats = [
            "D",
            "D/M",
            "M",
            "M/D",
            "D/M/YY",
            "M/D/YY",
            "YY/D/M",
            "YY/M/D",
            "D/M/YYYY",
            "M/D/YYYY",
            "YYYY/D/M",
            "YYYY/M/D",
        ];
    }
    const dateFormatParts = dateFormats.map((format) => format.split("/"));
    const formats = delimiters.reduce((acc, delimiter) => acc.concat(...dateFormatParts.map((format) => format.join(delimiter))), []);
    return ["YYYY-MM-DD", ...formats];
}
exports.dateRangeDatePasteFormat = dateRangeDatePasteFormat;
/**
 * @deprecated Use dateTimePasteFormats instead
 */
function dateRangeDateTimePasteFormat(dateFormats) {
    return dateFormats.reduce((result, dateFormat) => {
        return result.concat(...types_1.TIME_PASTE_FORMATS.reduce((subResult, timeFormat) => subResult.concat(...types_1.DATE_TIME_SEPARATORS.map((separator) => `${dateFormat}${separator}${timeFormat}`)), []));
    }, []);
}
exports.dateRangeDateTimePasteFormat = dateRangeDateTimePasteFormat;
/**
 * Checks if the boundaries of the DateRange need to be swapped and returns the correct value.
 *
 * If from_date or to_date is not present. Returns current value
 *
 * If from_date and to_date has equal date but from_date has include_time=true. Set to_date as from_date + 1 hour and include_time=true
 *
 * Else If from_date > to_date. Returns swapped from and to dates
 *
 * @param value             DateRange value
 * @param userPreferences   Current user preferences
 */
function swapDateRangeBoundaries(value, userPreferences) {
    var _a, _b;
    if (!((_a = value === null || value === void 0 ? void 0 : value.from_date) === null || _a === void 0 ? void 0 : _a.date) || !((_b = value === null || value === void 0 ? void 0 : value.to_date) === null || _b === void 0 ? void 0 : _b.date)) {
        return value;
    }
    const fromDate = (0, date_1.dateToMoment)(value.from_date, userPreferences);
    const toDate = (0, date_1.dateToMoment)(value.to_date, userPreferences);
    if (!fromDate || !toDate) {
        return value;
    }
    let updatedValue = { ...value };
    if (fromDate.format() > toDate.format()) {
        // If selected to_date's day equals from_date's day and from_date has selected time, we set to_date as from_date + 1 hour
        if (updatedValue.from_date.include_time &&
            fromDate.format("MM-DD-YYYY") === toDate.format("MM-DD-YYYY") &&
            !updatedValue.to_date.include_time) {
            fromDate.add(1, "hours");
            updatedValue.to_date = {
                date: fromDate.toISOString(),
                include_time: true,
            };
        }
        else {
            // Change from date and to date
            updatedValue = {
                from_date: updatedValue.to_date,
                to_date: updatedValue.from_date,
            };
        }
    }
    return updatedValue;
}
exports.swapDateRangeBoundaries = swapDateRangeBoundaries;
/**
 * Calculates fill progress between days in Date Range.
 * In percents from 0 to 100.
 *
 * @param value       Date Range field value
 * @param daysInRange  Number of days
 * @param timezone    Timezone string value
 */
function calculateDateRangePercentProgress(value, daysInRange, timezone) {
    if (!(value === null || value === void 0 ? void 0 : value.from_date) || !value.to_date || daysInRange <= 0) {
        return 0;
    }
    const toDate = (0, date_1.dateValueToDate)(value.to_date, timezone);
    const fromDate = (0, date_1.dateValueToDate)(value.from_date, timezone);
    if (!fromDate || !toDate) {
        return 0;
    }
    const today = (0, date_1.getNow)(timezone);
    const finishedDays = (0, date_1.daysDiffFns)(today, fromDate);
    const currentProgress = (finishedDays * 100) / daysInRange;
    if (currentProgress <= 0) {
        return 0;
    }
    if (currentProgress >= 100) {
        return 100;
    }
    return currentProgress;
}
exports.calculateDateRangePercentProgress = calculateDateRangePercentProgress;
function generateDisplayFormatDates(timezone) {
    const today = (0, date_fns_1.startOfDay)((0, date_1.getNow)(timezone));
    const rangeStart = (0, date_fns_1.addDays)(today, -10);
    const rangeEnd = (0, date_fns_1.addDays)(today, 20);
    const dateFrom = (0, date_1.dateToDateValue)(rangeStart, false, timezone);
    const dateTo = (0, date_1.dateToDateValue)(rangeEnd, false, timezone);
    return { from_date: dateFrom, to_date: dateTo };
}
exports.generateDisplayFormatDates = generateDisplayFormatDates;
/**
 * Returns days diff between dates in DateRange.
 *
 * It doesn't take into account time in dates.
 */
function dateRangeDaysDiff(dateRange, timezone) {
    if (!dateRange.from_date || !dateRange.to_date) {
        return 0;
    }
    const fromDate = (0, date_1.dateValueToDate)(dateRange.from_date, timezone);
    const toDate = (0, date_1.dateValueToDate)(dateRange.to_date, timezone);
    if (!fromDate || !toDate) {
        return 0;
    }
    const diff = (0, date_fns_1.differenceInDays)((0, date_fns_1.startOfDay)(toDate), (0, date_fns_1.startOfDay)(fromDate));
    return diff + 1;
}
exports.dateRangeDaysDiff = dateRangeDaysDiff;
function isDateRangeValue(value) {
    if (!(0, object_1.isObject)(value)) {
        return false;
    }
    const hasAllProperties = "from_date" in value && "to_date" in value;
    if (!hasAllProperties) {
        return false;
    }
    return (0, date_1.isDateValue)(value.from_date) && (0, date_1.isDateValue)(value.to_date);
}
exports.isDateRangeValue = isDateRangeValue;
function isDateRangesEqual(dateRange1, dateRange2, timezone) {
    var _a, _b, _c, _d;
    if (!isDateRangeValue(dateRange1) || !isDateRangeValue(dateRange2)) {
        return (0, react_fast_compare_1.default)(dateRange1, dateRange2);
    }
    return ((0, date_1.isDateValuesEqual)((_a = dateRange1 === null || dateRange1 === void 0 ? void 0 : dateRange1.from_date) !== null && _a !== void 0 ? _a : (0, date_1.emptyDateValue)(), (_b = dateRange2 === null || dateRange2 === void 0 ? void 0 : dateRange2.from_date) !== null && _b !== void 0 ? _b : (0, date_1.emptyDateValue)(), timezone) &&
        (0, date_1.isDateValuesEqual)((_c = dateRange1 === null || dateRange1 === void 0 ? void 0 : dateRange1.to_date) !== null && _c !== void 0 ? _c : (0, date_1.emptyDateValue)(), (_d = dateRange2 === null || dateRange2 === void 0 ? void 0 : dateRange2.to_date) !== null && _d !== void 0 ? _d : (0, date_1.emptyDateValue)(), timezone));
}
exports.isDateRangesEqual = isDateRangesEqual;
function isEmptyDateRange(value) {
    var _a, _b, _c;
    return !((_b = (_a = value === null || value === void 0 ? void 0 : value.to_date) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = value === null || value === void 0 ? void 0 : value.from_date) === null || _c === void 0 ? void 0 : _c.date);
}
exports.isEmptyDateRange = isEmptyDateRange;
function removeTimeFromDateRange(value, timezone) {
    if (isEmptyDateRange(value)) {
        return value;
    }
    return {
        from_date: (0, date_1.removeTimeFromDateValue)(value.from_date, timezone),
        to_date: (0, date_1.removeTimeFromDateValue)(value.to_date, timezone),
    };
}
exports.removeTimeFromDateRange = removeTimeFromDateRange;
function getDateRangeSearchKey(field, fieldValue, userPreferences) {
    var _a, _b;
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    const stringValue = fieldLogic.valueToString(fieldValue, field, userPreferences);
    if (!stringValue) {
        return "";
    }
    const range = dateRangeToMoment(fieldValue, userPreferences);
    const fromDateYear = (_a = range.from_date.date) === null || _a === void 0 ? void 0 : _a.year().toString();
    const toDateYear = (_b = range.to_date.date) === null || _b === void 0 ? void 0 : _b.year().toString();
    let searchKey = stringValue;
    if (fromDateYear && !searchKey.includes(fromDateYear)) {
        searchKey = `${searchKey} ${fromDateYear}`;
    }
    if (toDateYear && !searchKey.includes(toDateYear)) {
        searchKey = `${searchKey} ${toDateYear}`;
    }
    return searchKey;
}
exports.getDateRangeSearchKey = getDateRangeSearchKey;
function addDurationToDateRangeValue(fieldValue, duration, userPreferences, includeTime) {
    const fromDate = (0, date_1.addDurationToDateValue)(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.from_date, duration, userPreferences, includeTime);
    const toDate = (0, date_1.addDurationToDateValue)(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.to_date, duration, userPreferences, includeTime);
    if (fromDate.date &&
        fromDate.include_time &&
        toDate.date &&
        toDate.include_time &&
        (0, date_1.cutDateTimezone)(fromDate.date) === (0, date_1.cutDateTimezone)(toDate.date)) {
        toDate.date = (0, date_1.toMomentDate)(toDate.date, userPreferences.locale.value, userPreferences.timezone.value, toDate.include_time)
            .add(1, "hour")
            .toISOString();
    }
    return { ...fieldValue, from_date: fromDate, to_date: toDate };
}
exports.addDurationToDateRangeValue = addDurationToDateRangeValue;
